import { AccessOptionsEnum } from 'redux-store/api/company-roles';

export const accessOptions = [
  {
    label: 'Can View',
    value: AccessOptionsEnum.CanRead,
  },

  {
    label: 'Can Add/Edit',
    value: AccessOptionsEnum.CanAddUpdate,
  },

  {
    label: 'Can Delete',
    value: AccessOptionsEnum.CanDelete,
  },
];

export const fileCabinetTablColumns = (publicFolders?: boolean, fromModal?: boolean) => {
  const columns: { id: number; name: string; tooltip?: boolean }[] = [{ id: 1, name: 'Item' }];

  if (!publicFolders) {
    columns.push({ id: 2, name: 'Permissions', tooltip: true });
  }

  if (publicFolders || fromModal) {
    columns.push({ id: 3, name: 'Size' }, { id: 4, name: '# of Files' });
  }

  if (!publicFolders) {
    columns.push({ id: 5, name: '' });
  }

  return columns;
};
